// Import Swiper core module.
import Swiper from 'swiper';

// Import Swiper modules.
// eslint-disable-next-line import/no-unresolved
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

// Configure Swiper to use modules.
Swiper.use([Navigation, Pagination, EffectFade]);

/**
 * Default slider
 */
export function initDefaultSlider() {
	const swiper = document.querySelector('.section-slider .swiper');

	if (!swiper) {
		return;
	}

	const currentIndex = document.querySelector('.section-slider .swiper-index .current');

	const defaultSlider = new Swiper(swiper, {
		speed: 500,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		init: true,
		slidesOffsetAfter: 0,
		slidesPerView: 'auto',
		spaceBetween: 0, // px
		navigation: {
			nextEl: '.section-slider .swiper-button-next',
			prevEl: '.section-slider .swiper-button-prev',
		},
		loop: false,
	});

	defaultSlider.on('slideChange', function () {
		const activeIndex = 1 + defaultSlider.activeIndex;

		// Update counter.
		currentIndex.textContent = activeIndex.toString().padStart(2, '0');
	});
}

/**
 * Problems slider
 */
export function initProblemsSlider() {
	const swiper = document.querySelector('.section-problems .swiper');

	if (!swiper) {
		return;
	}

	const problemsSlider = new Swiper(swiper, {
		init: true,
		freemode: true,
		mousewheel: true,
		slidesOffsetAfter: 0,
		slidesPerView: 'auto',
		spaceBetween: 20, // px
		loop: false,
		centeredSlides: true,
		centeredSlidesBounds: true,
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 40, // px
			},
		},
		pagination: {
			el: '.section-problems .swiper-pagination',
			type: 'bullets',
		},
	});
}

/**
 * Solutions slider
 */
export function initSolutionsSlider() {
	if (window.innerWidth > 1024) {
		return;
	}

	const swiper = document.querySelector('.section-solutions .swiper');

	if (!swiper) {
		return;
	}

	const solutionsSlider = new Swiper(swiper, {
		init: true,
		freemode: true,
		mousewheel: true,
		slidesOffsetAfter: 0,
		slidesPerView: 'auto',
		spaceBetween: 20, // px
		loop: false,
		centeredSlides: true,
		centeredSlidesBounds: true,
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 40, // px
			},
		},
		pagination: {
			el: '.section-solutions .swiper-pagination',
			type: 'bullets',
		},
	});
}

/**
 * Method slider
 */
export function initMethodSlider() {
	const swiper = document.querySelector('.section-method .swiper');

	if (!swiper) {
		return;
	}

	const currentIndex = document.querySelector('.section-method .swiper-index .current');

	const methodSlider = new Swiper(swiper, {
		init: true,
		slidesOffsetAfter: 0,
		slidesPerView: 1,
		spaceBetween: 20, // px
		navigation: {
			nextEl: '.section-method .swiper-button-next',
			prevEl: '.section-method .swiper-button-prev',
		},
		loop: false,
		breakpoints: {
			768: {
				spaceBetween: 20, // px
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 'auto',
			},
		},
	});

	methodSlider.on('slideChange', function () {
		currentIndex.textContent = (1 + methodSlider.activeIndex)
			.toString()
			.padStart(2, '0');
	});
}

/**
 * Effects slider
 */
export function initEffectsSlider() {
	const swiper = document.querySelector('.section-effects .swiper');

	if (!swiper) {
		return;
	}

	const currentIndex = document.querySelector('.section-effects .swiper-index .current');

	const effectSlider = new Swiper(swiper, {
		speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		init: true,
		slidesOffsetAfter: 0,
		slidesPerView: 'auto',
		spaceBetween: 0, // px
		navigation: {
			nextEl: '.section-effects .swiper-button-next',
			prevEl: '.section-effects .swiper-button-prev',
		},
		loop: false,
	});

	effectSlider.on('slideChange', function () {
		const activeIndex = 1 + effectSlider.activeIndex;

		// Update counter.
		currentIndex.textContent = activeIndex.toString().padStart(2, '0');

		// Update image.
		document.querySelector('.section-effects .image .active').classList.remove('active');
		document.querySelector( '.section-effects .image img:nth-child(' + activeIndex +  ')' ).classList.add('active');
	});
}

/**
 * Team slider
 */
export function initTeamSlider() {
	const swiper = document.querySelector('.section-team .swiper');

	if (!swiper) {
		return;
	}

	const teamSlider = new Swiper(swiper, {
		init: true,
		slidesOffsetAfter: 0,
		slidesPerView: 'auto',
		spaceBetween: 20, // px
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: {
			nextEl: '.section-team .swiper-button-next',
			prevEl: '.section-team .swiper-button-prev',
		},
		loop: false,
		breakpoints: {
			992: {
				spaceBetween: 40, // px
			},
			1280: {
				centeredSlides: false,
				centeredSlidesBounds: false,
			},
		},
		pagination: {
			el: '.section-team .swiper-pagination',
			type: 'progressbar',
		},
	});
}
